import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type BrokenImageProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const BrokenImage: FC<BrokenImageProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'broken-image'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
        >
            <polygon points="195.4,109 154.1,143.5 99.8,94.3 53.1,141 0,141 0,150 56.9,150 100.2,106.7 153.9,155.5 198.6,118 250,118 250,109" />
            <polygon points="36.5,122.3 36.5,36.5 213.5,36.5 213.5,95 222.5,95 222.5,27.5 27.5,27.5 27.5,122.3 27.5,127 36.5,127" />
            <polygon points="213.5,143.9 213.5,213.5 36.5,213.5 36.5,164.7 36.5,164 27.5,164 27.5,164.7 27.5,222.5 222.5,222.5 222.5,143.9 222.5,132 213.5,132" />
        </svg>
    );
};

export default BrokenImage;
